import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Homlokzat, üveg, vasszerkezet és egyéb felület tisztítás</Title>
        <p>
          A kültéri homlokzatok, üvegfelületek, vasszerkezetek folyamatosan ki vannak téve a környezeti, állati és egyéb
          szennyeződéseknek. Ezek legfőképp esztétikai gondokat jelentenek, de a homlokzaton például további károkat is
          okozhat, ami később jelentős összegű felújítással járhat. Felülettől függően magasnyomású tiszta vizes mosást
          szoktunk alkalmazni, ha szennyeződés olyan mértékű, vegyszert is használunk. Homlokzati vakolat esetén
          figyelembe vesszük a kellő távolságot és az épület állagát, a legnagyobb gondossággal járunk el.
          Üvegfelületeken a nagyobb szennyeződések miatt romlik a fényáteresztő képesség, illetve a látási viszonyok,
          ezért javasolt a rendszeres tisztítás.
        </p>
        <p>
          A napelemek teljesítményt befolyásolja szennyeződés, így érdemes azt évente legalább egyszer letakarítani,
          hogy mindig a legjobb hatásfokkal működhessen.
        </p>
        <p>
          A növények felkúszhatnak az épültek falán, a vakolatot tönkreteszi, valamint az ereszcsatornában dugulást
          okoznak. Emiatt az eső víz át bukik a csatornán és áztatja a falfelületet ezzel kárt okozva az épületben.
          Ezért évente legalább kétszer fontos az eresz tisztítás.
        </p>
        <ul>
          <li>Vakolat, kő felület tisztítása magasnyomású géppel</li>
          <li>Homokszórás kő, beton és fémfelületen</li>
          <li>Üveg felülettisztítás</li>
          <li>Vasszerkezet tisztítás</li>
          <li>Futó növény eltávolítása</li>
          <li>Ereszcsatorna tisztítás</li>
          <li>Siló tisztítás</li>
          <li>Sport létesítmények, sátrak tisztítása</li>
          <li>Napelemek tisztítása</li>
        </ul>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
